;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.MenuSideBar = Marionette.ItemView.extend({
		tagName: 'div',
		template: JST.MenuSideBar,
		ui: {
			"menu": ".side-bar-menu",
			"menu_item": ".side-bar-menu a"
		},
		events: {
			"click @ui.menu_item": "setActiveMenuItem"
		},
		initialize: function() {
			this.title = this.getOption('side_menu_title');
			this.items = this.getOption('side_menu_items');
		},
		render: function() {
			this.$el.html(this.template({
				title: this.title,
				items: this.items
			}));
			return this;
		},
		setActiveMenuItem: function(e){

			e.preventDefault();
			$(this.ui.menu).find('.active').removeClass('active');
			$(e.currentTarget).parent().addClass('active');
			Backbone.history.navigate($(e.currentTarget).attr('href'), {trigger: true});
		}
	})

}(window, APP, Backbone, Marionette, $, _));
